import React from 'react'

export default function Add() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path id="add-website" d="M14,4A10,10,0,1,0,24,14,10.011,10.011,0,0,0,14,4Zm4.25,10.75h-3.5v3.5a.75.75,0,0,1-1.5,0v-3.5H9.75a.75.75,0,0,1,0-1.5h3.5V9.75a.75.75,0,0,1,1.5,0v3.5h3.5a.75.75,0,0,1,0,1.5Z" transform="translate(-4 -4)" fill="#fff"/>
  </svg>
  
  )
}